// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2c-QH","projectLogo":"Logo_projectLogo__3NDLq","code4Logo":"Logo_code4Logo__1vqLI"};